// src/pages/ResetPasswordPage.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { getData } from '../../../webService/webservice.js';
import PasswordResetPopup from '../../../components/popup/ResetPasswordPopup.jsx';

const ResetPasswordPage = ({ onClose }) => {
    const { token } = useParams();
    const navigate = useNavigate();

    const [backgroundImages, setBackgroundImages] = React.useState([]);
    const [bgIndex, setBgIndex] = React.useState(0);

    React.useEffect(() => {
        const fetchBackgrounds = async () => {
            try {
                const response = await getData('appearance/backgrounds');
                if (response?.data?.results) {
                    const images = response.data.results
                        .filter(bg => bg?.uri)
                        .map(bg => {
                            const baseUrl = process.env.REACT_APP_API_URL.replace(/\/$/, "");
                            const uri = bg.uri.replace(/^\/?/, "/");
                            return `${baseUrl}${uri}`;
                        });

                    console.log("Background Images:", images);
                    setBackgroundImages(images);
                }
            } catch (error) {
                console.error("Failed to load backgrounds:", error);
            }
        };
        fetchBackgrounds();
    }, []);

    React.useEffect(() => {
        if (backgroundImages.length === 0) return;
        const interval = setInterval(() => {
            setBgIndex((prev) => (prev + 1) % backgroundImages.length);
        }, 6000);
        return () => clearInterval(interval);
    }, [backgroundImages]);

    const handleClose = () => {
        if (onClose) {
            onClose();
        } else {
            navigate('/login');
        }
    };

    return (
        <div className='reset-password-bg'>

            {backgroundImages.map((img, index) => (
                <div
                    key={index}
                    className={`login-bg-img ${index === bgIndex ? 'active' : ''}`}
                    style={{
                        backgroundImage: `url("${img}")`
                    }}
                />
            ))}
            <div className='reset-password-container'>
                <PasswordResetPopup token={token} onClose={handleClose} />
            </div>
        </div>
    );
};

export default ResetPasswordPage;
